/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import { post, CashRequestOptions } from '@cash-web/shared-util-fetch'
import {GetShiftRequest} from '@cash-web/protos/squareup/timecards/timecards_service.pb'
import {GetShiftResponse} from '@cash-web/protos/squareup/timecards/timecards_service.pb'


export const getShift = (request: GetShiftRequest, options?: CashRequestOptions) => post<GetShiftRequest, GetShiftResponse>("/proxy/services/squareup.timecards.PublicTimecardsService/GetShift", request, {...options, rejectOnError: true })